export var wrapper = 'w-full flex flex-col justify-start pt-4 px-7';
export var titleWrapper = 'w-full flex flex-row justify-between items-center mb-2';
export var actionCircle = 'rounded-full p-3 bg-primary ';
export var actionWrapper = 'flex flex-col items-center justify-items-center mr-6 mb-1';
export var actionsFlexWrapper = 'w-full flex flex-row justify-start items-center py-2';
//# sourceMappingURL=action-select.style.js.map